export default __webpack_public_path__ + "static/media/iplanning.6ea765f5.png";